import { Num } from '../utils';
export class MapCoordinates {
public lat: number;
public lng: number;
/**
 * @param {?} lat
 * @param {?} lng
 */
constructor(lat: number, lng: number) {
    if(Num.isNaN(lat, lng)) {
      throw Error('Latitude (lat) and Longitude (lng) must be valid numbers');
    }

    this.lat = lat;
    this.lng = lng;
  }

}

function MapCoordinates_tsickle_Closure_declarations() {
/** @type {?} */
MapCoordinates.prototype.lat;
/** @type {?} */
MapCoordinates.prototype.lng;
}
